import React from "react";

function Footer() {
  return (
    <footer className="bg-gray-100 mt-16">
      <div className="bg-gray-700 px-8 text-white py-1 text-gray-600 flex items-center justify-between" style={{ height: "50px" }}>
        <ul className="flex font-bold">
          <li className="mr-4">
            <a href="https://www.swift.com/privacy-statement">
              <span>Privacy statement</span>
            </a>
          </li>
          <li className="mr-4">
            <a href="https://www.swift.com/terms-of-use">
              <span>Terms of use</span>
            </a>
          </li>
          <li className="mr-4">
            <a href="https://www.swift.com/contact-us?source=sup_pg_lite2">
              <span>Contacts</span>
            </a>
          </li>
          <li className="mr-4">
            <a href="https://www.swift.com/website-feedback?source=sup_pg_lite2">
              <span>Feedback</span>
            </a>
          </li>
        </ul>
        <div className="flex items-center justify-between h-full">
          <div>© 2020 SWIFT</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
